var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        title: "审核",
        "class-name": "vertical-center-modal",
        width: "600",
        loading: _vm.isLoading,
        "mask-closable": false,
      },
      model: {
        value: _vm.modalData.show,
        callback: function ($$v) {
          _vm.$set(_vm.modalData, "show", $$v)
        },
        expression: "modalData.show",
      },
    },
    [
      _vm.isLoading
        ? _c(
            "Spin",
            { staticClass: "custom-spin", attrs: { size: "large", fix: "" } },
            [
              _c("Icon", {
                staticClass: "spin-icon",
                attrs: { type: "ios-loading" },
              }),
              _c("div", [_vm._v("提交中...")]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "Form",
        {
          ref: "approveForm",
          staticClass: "audit-form",
          attrs: {
            model: _vm.modalData,
            rules: _vm.formRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-content" },
            [
              _c(
                "FormItem",
                {
                  staticClass: "status-item",
                  attrs: { label: "审核结果", prop: "approveStatus" },
                },
                [
                  _c(
                    "RadioGroup",
                    {
                      staticClass: "status-radio-group",
                      model: {
                        value: _vm.modalData.approveStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.modalData, "approveStatus", $$v)
                        },
                        expression: "modalData.approveStatus",
                      },
                    },
                    [
                      _c(
                        "Radio",
                        {
                          staticClass: "radio-item success",
                          attrs: { label: "通过" },
                        },
                        [_c("span", [_vm._v("通过")])]
                      ),
                      _c(
                        "Radio",
                        {
                          staticClass: "radio-item error",
                          attrs: { label: "驳回" },
                        },
                        [_c("span", [_vm._v("驳回")])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "FormItem",
                {
                  staticClass: "remark-item",
                  attrs: {
                    label: "审核备注",
                    prop: "approveRemark",
                    rules: _vm.remarkRules,
                  },
                },
                [
                  _c("Input", {
                    staticClass: "remark-textarea",
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入审核意见（驳回时必填）",
                      "show-word-limit": "",
                      maxlength: 200,
                    },
                    model: {
                      value: _vm.modalData.approveRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.modalData, "approveRemark", $$v)
                      },
                      expression: "modalData.approveRemark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "Button",
            {
              staticClass: "cancel-btn",
              attrs: { type: "text" },
              on: { click: _vm.close },
            },
            [_vm._v("取消")]
          ),
          _c(
            "Button",
            {
              staticClass: "confirm-btn",
              attrs: {
                type: _vm.confirmBtnType,
                loading: _vm.isLoading,
                disabled: _vm.isSubmitDisabled,
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }